var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState, } from "react";
import useLastFocusedElement from "../hooks/useLastFocusedElement";
export var defaultState = {
    crossBorderModal: {
        isOpen: false,
        isOpenedFromModal: false,
        crossBorderUrl: "",
    },
    shouldShowErrorPage: false,
    reopenQuestionsModal: false,
};
var VantageContext = createContext({
    state: defaultState,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    dispatch: function (_newState) {
        throw new Error("No dispatch");
    },
    navigateTo: function () {
        throw new Error("No navigateTo");
    },
    captureLastFocusedElement: function () {
        throw new Error("No captureLastFocusedElement");
    },
    restoreFocus: function () {
        throw new Error("No restoreFocus");
    },
});
VantageContext.displayName = "VantageContext";
export var useVantageContext = function () {
    var value = useContext(VantageContext);
    if (!value) {
        throw new Error("No Vantage context value");
    }
    return value;
};
var VantageContextProvider = function (_a) {
    var initialState = _a.initialState, navigateTo = _a.navigateTo, children = _a.children;
    var _b = useState(initialState !== null && initialState !== void 0 ? initialState : defaultState), state = _b[0], setState = _b[1];
    var _c = useLastFocusedElement(), captureLastFocusedElement = _c.captureLastFocusedElement, restoreFocus = _c.restoreFocus;
    var dispatch = useCallback(function (newState) {
        setState(function (prevState) { return (__assign(__assign({}, prevState), newState)); });
    }, []);
    var contextValue = useMemo(function () { return ({
        state: state,
        dispatch: dispatch,
        navigateTo: navigateTo,
        captureLastFocusedElement: captureLastFocusedElement,
        restoreFocus: restoreFocus,
    }); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]);
    return (_jsx(VantageContext.Provider, __assign({ value: contextValue }, { children: children })));
};
export default VantageContextProvider;
